var exports = {
  "k": "x93eb46d8--cd66e6--container",
};

module.exports = exports;
